export default {"src":"/_next/static/media/404_Manny.02544f3d.svg","height":241,"width":305};